let onChangecheck = (e) => {
    console.log(e.target.checked);
}

let heightCanvasFullScreen = (id) => {
    let box = document.getElementById(`boxPanelContent_${id}`);
    if (!box.classList.contains('col-10')) {
        box.classList.add('col-10');
    }
    let width = box.clientWidth - 30;
    box.classList.remove('col-10');
    return {width};
};

let onFocusInput = (id) => {
    let input = document.getElementById(id);
    input.focus();
}

function calculateMaxHeightIconList(mobile) {
    if (!mobile) {
        var res = 33 + 5 + 20 + 125 + 28 + 28;
        var box = document.getElementById('iconListModal');
        var win = window.innerHeight;
        var total = win - res;
        box.style.height = `${total}px`;
    } else {
        var box1 = document.getElementById('iconListModal');
        box1.style.maxHeight = '52vh';
    }
}

let animateFocusControl = () => {
    let ripple = document.querySelectorAll('.ripple-container');
    [].forEach.call(ripple, function(e) {
        e.addEventListener('click', function(e) {
            let offset = this.parentNode.getBoundingClientRect();
            let effect = this.querySelector('.ripple-effect');

            effect.style.top = (e.pageY - offset.top) + "px";
            effect.style.left = (e.pageX - offset.left) + "px";

            this.classList.add('ripple-effect-animation');
        }, false);
        e.addEventListener('animationend', removeAnimation);
        e.addEventListener('webkitAnimationEnd', removeAnimation);
        e.addEventListener('oanimationend', removeAnimation);
        e.addEventListener('MSAnimationEnd', removeAnimation);
    });

    function removeAnimation() {
        if (this.classList) {
            this.classList.remove('ripple-effect-animation');
        } else {
            this.className = this.className.replace(new RegExp('(^|\\b)' + 'ripple-effect-animation'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }
}

let checkFullPageBackgroundImageScript = () => {
    const $page = $('.full-page');
    const image_src = $page.data('image');
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('register-page');
    if (image_src !== undefined) {
        const image_container = '<div class="full-page-background" style="background-image: url(' + image_src + ') "/>'
        $page.append(image_container);
    }
};

let dropdownActiveScroll = (classSelect) => {

    setTimeout(() => {

        const menu = document.querySelectorAll('.' + classSelect)[0];
        let index = 0;

        if (menu && menu.classList.contains('show')) {
            const children = menu.childNodes;
            for (const ele of children) {
                if (ele.classList ) {
                    if (ele.classList.contains('active')) {
                        //console.log(ele);
                        menu.scrollTo(0, ele.offsetHeight * (index));
                        break;
                    }
                    index++;
                }
            }
        }

    }, 200);

}

function calcHeightBoxMap() {
    var navbar = document.querySelectorAll('.navbar');
    var map = document.querySelector('#map');
    var cardHeader = document.querySelector('#card-header-map');
    var rowFileds = document.querySelector('#row-fields');
    var footer = document.querySelectorAll('.footer');
    footer[0].style.padding = '0';
    if (navbar[0]) {
        map.style.height = `calc(100vh - (${navbar[0].offsetHeight}px + 63px + ${cardHeader.offsetHeight}px + ${rowFileds.offsetHeight}px + (0.25rem *2) + ${footer[0].offsetHeight}px))`;
    }
}

function getPosition(e) {
    var posx = 0, posy = 0;
    if (!e) var e = window.event;
    if (e.pageX || e.pageY) {
        posx = e.pageX;
        posy = e.pageY;
    } else if (e.clientX || e.clientY) {
        posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }
    return {
        x: posx,
        y: posy
    };
}

function positionMenu(e) {
    var menu = document.querySelector('#context-menu');
    var clickCoords = getPosition(e);
    var clickCoordsX = clickCoords.x;
    var clickCoordsY = clickCoords.y;
    var menuWidth = menu.offsetWidth + 4;
    var menuHeight = menu.offsetHeight + 4;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    if ( (windowWidth - clickCoordsX) < menuWidth ) {
        menu.style.left = (windowWidth - menuWidth)-0 + "px";
    } else {
        menu.style.left = clickCoordsX-0 + "px";
    }

    if ( Math.abs(windowHeight - clickCoordsY) < menuHeight ) {
        menu.style.top = (windowHeight - menuHeight)-0 + "px";
    } else {
        menu.style.top = clickCoordsY-0 + "px";
    }

    menu.style.display = 'block';
}

let changeStatusCheck = (id) => {
    const check = document.querySelector('#' + id);
    const checkboxs = document.querySelectorAll('.checkBoxIcons');
    const r = [];
    checkboxs.forEach(c => {
        if ((c).checked) {
            r.push(c);
        }
    });

    if (r.length > 5) {
        check.checked = false;
    }
};
